import React, { useState } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import constants from "../../utils/constants";
import { useEffect } from "react";
import obj from "../../utils/constants";
import { isEmpty } from "lodash";
import { Helmet } from "react-helmet";
const ViewPremiumFancy = ({ object, onHide, setObject }) => {
  const params = useParams();
  const [isLoader, setLoader] = useState(false);
  const [detailsData, setDetailsData] = useState({});
  const [search_params, setSearchParams] = useState({
    eventId: object?.eventId,
    selectionId: object?.selectionId,
    marketId: object?.marketId,
    userId: object?.userId,
    userType: object?.userType,
    betType: object?.type == "Book Maker" ? "bookmaker" : "betFair",
  });

  const setFunc = (object) => {
    if (!isEmpty(object)) {
      setSearchParams({
        eventId: object?.eventId,
        selectionId: object?.selectionId,
        marketId: object?.marketId,
        userId: object?.userId,
        userType: object?.userType,
        betType: object?.type == "Book Maker" ? "bookmaker" : "betFair",
      });
    }
  };
  // useEffect(() => {
  //   setFunc(object);
  // }, [object]);

  // useEffect(() => {
  //   getDetails();
  // }, [search_params]);

  const getDetails = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.riskManagementSPortPremiumDetails +
        `?eventId=${search_params.eventId}&marketId=${search_params.marketId}&userType=${search_params.userType}&userId=${search_params.userId}`
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results) {
          setDetailsData(response_users.results);
        }
      }
    }
  };

  return (
    // <section className="main-inner-outer py-4">
    <Modal size="xl" show={true} onHide={onHide}>
      <Modal.Body>
        <section className="account-table">
          <div className="container-fluid">
            <div className="db-sec d-flex justify-content-between align-items-center mb-2">
              <h2 className="common-heading">
                {/* {detailsData?.eventName} ( {params?.type} ) */}
              </h2>
              <Button className="green-btn" onClick={() => onHide()}>
                Close
              </Button>
            </div>

            {object?.length > 0 && (
              <div className="responsive">
                <Table>
                  <tbody>
                    <tr>
                      <td rowspan="2">
                        <strong> Player ID</strong>
                      </td>{" "}
                      <td rowspan="2">
                        <strong> Selection</strong>
                      </td>
                      <td rowspan="2">
                        <strong> Bet Amount</strong>
                      </td>{" "}
                      <td rowspan="2">
                        <strong> Profit Amount</strong>
                      </td>{" "}
                      <td rowspan="2">
                        <strong> Loss Amount</strong>
                      </td>
                    </tr>
                  </tbody>

                  <tbody className="new-match-tbody">
                    {object &&
                      object?.length > 0 &&
                      object?.map((res) => {
                        return (
                          <>
                            <tr>
                              <td className="text-start">{res?.clientName}</td>
                              <td class="text-start"> {res?.selectionId}</td>
                              <td class="text-start">
                                {" "}
                                {res?.positionLoseAmount?.toFixed(2)}
                              </td>
                              <td class="text-start">
                                <p class="text-success">
                                  ({res?.positionProfitAmount?.toFixed(2)})
                                </p>
                              </td>
                              <td class="text-start">
                                <p class="text-danger">
                                  (-{res?.positionLoseAmount?.toFixed(2)})
                                </p>
                              </td>
                            </tr>
                          </>
                        );
                      })}

                    {isEmpty(object) ? (
                      <tr>
                        <td colSpan={9}>No records found</td>
                      </tr>
                    ) : null}
                  </tbody>
                </Table>
              </div>
            )}
          </div>
        </section>
      </Modal.Body>
    </Modal>
    // </section>
  );
};

export default ViewPremiumFancy;
